import { render } from "./TagQuery.vue?vue&type=template&id=7c4b2811&ts=true"
import script from "./TagQuery.vue?vue&type=script&lang=ts"
export * from "./TagQuery.vue?vue&type=script&lang=ts"

import "./TagQuery.vue?vue&type=style&index=0&id=7c4b2811&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__